import './webpack-public-path';
require('./bootstrap');
require('alpinejs');
window.Vue = require('vue').default;
import router from './router';
import store from './store';
import VueSocialSharing from 'vue-social-sharing';
import LazyTube from 'vue-lazytube';
import VueSwal from 'vue-swal';
import VueApexCharts from 'vue-apexcharts';
import VueCoreVideoPlayer from 'vue-core-video-player';
Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);
import Vuetify from 'vuetify';
import ViewUI from 'view-design';
import Vuex from 'vuex';
import uploader from 'vue-simple-uploader';
Vue.use(VueSwal);
import 'view-design/dist/styles/iview.css';
import VueEditor from 'vue2-editor';
import common from './common';
import Vuelidate from 'vuelidate';
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/dist/vuetify.min.css';

import 'vue-advanced-cropper/dist/style.css';
import moment from 'moment';

Vue.prototype.moment = moment;

import VueTour from 'vue-tour';
require('vue-tour/dist/vue-tour.css');
import '../assets/global.css';
import '../css/ultraship-tokens.css';
import '../css/admin-shell.css';
import { getAdminTheme, initAdminTheme, resyncAdminTheme } from './components/layouts/adminTheme';

import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
const globalOptions = {
  mode: 'auto',
  dropdownOptions: {
    showDialCode: true,
  },
};

Vue.use(VueTelInput, globalOptions);

//for Permissions

import Permissions from './mixins/Permissions';
Vue.mixin(Permissions);

Vue.use(VueTour);
Vue.use(Vuelidate);
Vue.mixin(common);
Vue.use(LazyTube);
Vue.use(Vuetify);
Vue.use(ViewUI);
Vue.use(Vuex);
Vue.use(VueSocialSharing);
Vue.use(uploader);
Vue.use(VueEditor);
Vue.use(VueCoreVideoPlayer);

window.Permissions = window.Permissions || [];

Vue.component('admin-page', () => import('./components/Admin/Dashboard/index'));
Vue.component('Frontapp', () => import('./components/Frontapp.vue'));
Vue.component('headers', () => import('./components/FrontLayout/headmenu2.vue'));

Vue.component('user-page', () => import('./components/Seller/index.vue'));
Vue.component(
  'mobileVarification',
  () => import('./components/Admin/Authentication/MobileVarification.vue')
);
Vue.component(
  'newWelcome',
  () => import('./components/Admin/Authentication/NewMobileVerification.vue')
);
Vue.component('delete-account', () => import('./components/DeleteAccount.vue'));
Vue.component(
  'recover-account',
  () => import('./components/Admin/Authentication/recover_account.vue')
);
Vue.component('userType', () => import('./components/Admin/Authentication/UserType.vue'));
Vue.component('usersType', () => import('./components/Admin/Authentication/NewUserType.vue'));
Vue.component('signupFinish', () => import('./components/Admin/Authentication/FinishSigning.vue'));

Vue.component('usersCreated', () => import('./components/Admin/Authentication/UserCreated.vue'));

Vue.component('category-hire-page', () => import('./components/FrontLayout/Subcategory/hire'));
Vue.component('category-learn-page', () => import('./components/FrontLayout/Subcategory/learn'));
Vue.component('category-earn-page', () => import('./components/FrontLayout/Subcategory/earn'));

Vue.component('course-details', () => import('./components/FrontLayout/Trainings/coursedetails'));

Vue.component('hire-page', () => import('./components/Admin/Authentication/HireSection.vue'));
Vue.component('earn-page', () => import('./components/Admin/Authentication/EarnSection.vue'));
Vue.component('learn-page', () => import('./components/Admin/Authentication/LeanSection.vue'));

import AdminLogin from './components/Admin/Authentication/AdminLogin.vue';
Vue.component('admin-login', AdminLogin);
Vue.component('account-login', () => import('./components/Admin/Authentication/AccountLogin.vue'));

Vue.component(
  'account-forget',
  () => import('./components/Admin/Authentication/AccountForgetFigma.vue')
);
Vue.component(
  'account-userresetforget',
  () => import('./components/Admin/Authentication/AccountForgetReset.vue')
);
Vue.component(
  'account-register',
  () => import('./components/Admin/Authentication/AccountRegister.vue')
);
Vue.component(
  'account-newregister',
  () => import('./components/Admin/Authentication/NewAccountRegister.vue')
);
Vue.component(
  'account-forgot',
  () => import('./components/Admin/Authentication/AccountForgot.vue')
);
Vue.component('testing', () => import('./components/testing.vue'));
Vue.component('freelancer', () => import('./components/Admin/LandingPage/zooplancerSignUp.vue'));
Vue.component('client', () => import('./components/Admin/LandingPage/clientSignUp.vue'));
Vue.component('client-page', () => import('./components/pages/client/index.vue'));
Vue.component('freelancer-page', () => import('./components/pages/freelancer/index.vue'));

Vue.component('trainer-page', () => import('./components/pages/trainer/index.vue'));
Vue.component('student-page', () => import('./components/pages/student/index.vue'));
Vue.component(
  'class-details',
  () => import('./components/FrontLayout/Subcategory/classDetails/class_details.vue')
);
Vue.component(
  'class-preview',
  () => import('./components/FrontLayout/Subcategory/classDetails/preview_class.vue')
);
Vue.component(
  'subscription-details',
  () => import('./components/FrontLayout/Subcategory/Subscription/subscription.vue')
);
Vue.component(
  'project-details',
  () => import('./components/FrontLayout/Project/projectdetails.vue')
);
Vue.component('project-bids', () => import('./components/Seller/Project/projectsubmitbid.vue'));
Vue.component(
  'project-bidedit',
  () => import('./components/Seller/Project/bidEditByFreelancer.vue')
);
Vue.component(
  'author-details',
  () => import('./components/FrontLayout/Subcategory/classDetails/author_details.vue')
);

if (process.env.MIX_APP_ENV === 'production') {
  Vue.config.devtools = false;
  Vue.config.debug = false;
  Vue.config.silent = true;
}

const app = new Vue({
  el: '#app',

  components: {
    'main-content3': () => import('./components/FrontLayout/index3.vue'),
  },
  vuetify: new Vuetify({
    icons: {
      iconfont: 'mdi',
    },
    theme: {
      dark:
        typeof document !== 'undefined' && document.body.classList.contains('admin-us')
          ? getAdminTheme() === 'dark'
          : false,
      themes: {
        light: {
          primary: '#05a5fb',
          secondary: '#003b58',
        },
        dark: {
          primary: '#05a5fb',
          secondary: '#7dd3fc',
          background: '#0b1018',
          surface: '#151c2a',
        },
      },
    },
  }),
  router,
  store,
  created() {
    this.$store.dispatch('initializeAppContext');
  },
  mounted() {
    window.__adminVue = this;
    if (document.body.classList.contains('admin-us')) {
      initAdminTheme();
    }
  },
});

window.__adminVue = app;

if (typeof document !== 'undefined' && document.body.classList.contains('admin-us')) {
  router.afterEach(() => {
    requestAnimationFrame(() => resyncAdminTheme());
  });
}
